// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-button.is-plain[data-v-d26d0ef0]{--el-button-active-text-color:var(--el-color-primary);--el-button-active-border-color:var(--el-color-primary)}.el-button--primary.is-plain[data-v-d26d0ef0]{--el-button-border-color:var(--el-color-primary-light-3)}.el-link.el-link--primary[data-v-d26d0ef0]:hover{color:var(--el-color-primary-light-3)}.preview-wrapper[data-v-d26d0ef0]{padding-bottom:2rem;height:34rem}[data-v-d26d0ef0] .el-dialog .el-dialog__header{background:#fff}", ""]);
// Exports
module.exports = exports;
